import React from "react";
import QuoteStepBase from '../../components/QuoteStepBase'
import ButtonContinue from "../../components/ButtonContinue";
import { Alert } from 'react-bootstrap'
import { IQuoteStepState, IQuoteStepComponentProps } from "../../components/interfaces";
import { QuoteStep } from "./QuoteStepLayout";
import { connect } from "react-redux";
import { FULL_QUOTE_STEPS } from "../../AppConstants";
import { PATHS } from "../../AppConstants";
import { quoteStepChanged } from "../../state/appActions";
import { IBindResult } from "../../classes/ExternalQuote";
import { IAppState } from "../../state/interfaces";
import Utilities from "../../classes/Utilities";

interface IState extends IQuoteStepState {
}

interface IProps extends IQuoteStepComponentProps {
    bindResult: IBindResult | null
}

class Finish extends QuoteStepBase<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.next = this.next.bind(this);

        this.state = {
            updatingStore: false,
            errors: null
        }
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.reportCurrentStep();
    }

    next() {
        this.props.history.push(PATHS.FQ_DOCUMENTS);
        //this.setState({ updatingStore: true }, () => {
        //    this.props.updateAppState({
        //        agreeDrivers: this.state.agreeDrivers,
        //        agreeVehicles: this.state.agreeVehicles,
        //        agreeOtherDrivers: this.state.agreeOtherDrivers,
        //        agreeSalvage: this.state.agreeSalvage
        //    })
        //        .then(() => {
        //            this.setState({ updatingStore: false }, () => this.props.history.push(PATHS.FQ_PAYMENT));
        //        },
        //            () => {
        //                this.setState({ ...this.state, updatingStore: false });
        //            });
        //});
    }

    render() {
        return (
            <QuoteStep id="finish" className="policy-details">
                {
                    this.props.bindResult?.isSuccess 
                        ?
                        <div>
                            <div className="titleArea">
                                <h5>Thank you!</h5>
                            </div>

                            <p className="info">Please click this link get your instant PROOF OF COVERAGE and other policy documents.</p>

                            <div className="btnContainer">
                                <ButtonContinue
                                    label="Download ID Card Now"
                                    className="btn-sign"
                                    disabled={this.state.updatingStore}
                                    showLoading={this.state.updatingStore}
                                    onClick={this.next} />
                            </div>
                        </div>
                        :
                        <div>
                            <Alert variant={"danger"}>
                                <p><strong className="text-uppercase">Sorry! Can not process your quote!</strong></p>
                                <p>Please review errors below</p>
                                <ul>
                                    {
                                        this.props.bindResult?.errors.map((error) => (
                                            <li key={Utilities.uniqueId()}>
                                                <p className="text-uppercase">
                                                    {error}
                                                </p>
                                            </li>
                                        ))
                                    }
                                </ul>
                                <p><a href="/d2c" className="font-weight-bold m-b-0"><i className="fas fa-chevron-left"></i> Home</a></p>
                            </Alert>
                        </div>
                }
                

            </QuoteStep>
        );
    }
}

let mapProps = (state: IAppState) => {
    return {
        bindResult: state.externalQuote?.bindResult
    };
};

let mapDispatch = (dispatch: any) => {
    return {
        reportCurrentStep: () => dispatch(quoteStepChanged(FULL_QUOTE_STEPS.FINISH))
    };
};

export default connect(mapProps, mapDispatch)(Finish);
